"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonAction = exports.ModalShareClose = exports.ModalShareHeader = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.ModalShareHeader = (0, flora_react_1.styled)(flora_react_1.ModalHeader, {
    backgroundColor: '$nonInteractiveAltAuxiliar',
    color: '$backgroundAltSecondary',
    fontWeight: '$medium',
    position: 'relative',
});
exports.ModalShareClose = (0, flora_react_1.styled)(flora_react_1.ModalCloseButton, {
    borderColor: '$backgroundAltSecondary',
    borderRadius: '$pill',
    borderStyle: 'solid',
    borderWidth: '$hairline',
    height: 24,
    padding: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 24,
    svg: {
        height: 16,
        width: 16,
        path: {
            fill: '$backgroundAltSecondary',
        },
    },
});
exports.ButtonAction = (0, flora_react_1.styled)(flora_react_1.Button, {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 'auto !important',
    marginRight: '$6',
    i: {
        alignItems: 'center',
        background: '$backgroundAltPrimary',
        borderRadius: '$pill',
        display: 'flex',
        height: 48,
        justifyContent: 'center',
        marginBottom: '$2',
        width: 48,
    },
    variants: {
        type: {
            facebook: {
                i: {
                    backgroundColor: '$facebook',
                },
            },
            whatsapp: {
                i: {
                    backgroundColor: '$whatsapp',
                },
            },
            copy: {
                i: {
                    backgroundColor: '$actionableDefault',
                },
            },
        },
    },
});
